import { useIsMobile } from "@/hooks/use-mobile";

function Loading() {
    const isMobile = useIsMobile();

    if (isMobile) {
        return (
            <div className="flex flex-col mx-auto my-auto">
                <div className="flex flex-row mx-auto w-[50%]">
                    <img src="/PPMeasy_logo.svg" />
                </div>
                <div className="flex flex-row" >
                    <div className="flex flex-row m-auto">
                        <span className="loader"></span>
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div className="flex flex-col mx-auto">
            <div className="flex flex-row w-[25%] mx-auto mt-[20%]">
                <img src="/PPMeasy_logo.svg" />
            </div>
            <div className="flex flex-row" >
                <div className="flex flex-row m-auto">
                    <span className="loader"></span>
                </div>
            </div>
        </div>
    )
}

export default Loading